<field-text {(field)}="code" format="pint" required="true" required-default-value="1000"></field-text>
<field-textarea label="" {(field)}="commandText" max="270" required="true" col="12 12"></field-textarea>
